import type { UrlFilterData } from '@hotjar/feedback';
import type { RadioTextFilterValue } from '@hotjar/global-filters';
import { PageURLFilter, RadioTextFilterOperation } from '@hotjar/global-filters';
import { useCallback } from 'react';
import type { ChangeFilter, RemoveFilter } from './FilterTypes';

export const PageUrlFilter = ({
  filter,
  onChange,
  onRemove,
}: {
  filter: UrlFilterData;
  onChange: ChangeFilter<UrlFilterData>;
  onRemove: RemoveFilter<UrlFilterData>;
}): JSX.Element => {
  const onRemoveFilter = useCallback(() => {
    onRemove(filter);
  }, [onRemove, filter]);

  const onApply = useCallback(
    (newValue: RadioTextFilterValue | undefined) => {
      switch (newValue?.operation) {
        case RadioTextFilterOperation.IS:
        case RadioTextFilterOperation.CONTAINS:
        case RadioTextFilterOperation.NOT_CONTAINS:
        case RadioTextFilterOperation.STARTS_WITH:
        case RadioTextFilterOperation.ENDS_WITH:
          onChange(filter, newValue);
          break;
        default:
          onChange(filter, undefined);
          break;
      }
    },
    [onChange, filter],
  );

  return (
    <PageURLFilter
      currentValue={filter.value}
      onApply={onApply}
      onRemove={filter.value !== undefined ? onRemoveFilter : undefined}
      isInactive={filter.value === undefined}
    />
  );
};
